import { Injectable } from '@angular/core';
import { ToastService } from '@skylab-angular-shared/ui';
import { FormState } from '../form-state';
import { FormStateHandler } from './form-state-handler';

export interface SuccessContext {
    message: string;
}

@Injectable({providedIn: 'root'})
export class SuccessHandler extends FormStateHandler<SuccessContext> {
    public constructor(
        public readonly toastService: ToastService
    ) {
        super();
    }

    protected get formState(): FormState {
        return FormState.Success;
    }

    protected handle(ctx: SuccessContext): void {
        this.toastService.showAsync({
            type: 'success',
            text: ctx.message,
        });
    }
}
